<template>
	<div class="jobsyoumanage">
		<div class="title" v-if="$vuetify.breakpoint.mdAndUp">
			<div v-for="(title, index) in titles" :key="index" class="title-item">
				<div>{{ title }}</div>
				<div class="icon-sort">
					<SortUpDown
						v-if="index !== 0"
						class="sort-up-down"
						@click="onSort(index)"
					/>
				</div>
			</div>
		</div>
		<div class="table-wrap" v-if="$vuetify.breakpoint.mdAndUp">
			<div class="table-container">
				<div v-for="job in jobs_list" :key="job.job_id" class="table-row">
					<div
						class="btn-add"
						@click.stop="onAddTimesheet(job)"
					>
						Add Timesheet
					</div>
					
					<div
						class="table-col-content"
						@click.stop="
							$router.push({ name: 'View Job', params: { id: job.job_id } })
						"
					>
						<div>{{ job.job_code }}</div>
						<div>{{ job.job_short }}</div>
						<div>{{ job.job_status }}</div>
						<div>{{ job.job_division }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="table-wrap-xs" v-if="$vuetify.breakpoint.smAndDown">
			<div class="table">
				<div v-for="job in jobs_list" :key="job.job_id" class="table-row-xs">
					<div class="btn-add-xs" @click.stop="onAddTimesheet(job)">
						<v-icon dark>
							mdi-plus
						</v-icon>
					</div>
					<div
						class="table-col-content-xs"
						@click.stop="$router.push({ name: 'View Job', params: { id: job.job_id } })" >
						<div class="text-over">{{ job.job_short }}</div>
						<div class="text-code">{{ job.job_code }} </div>
					</div>
				</div>
			</div>
		</div>
		<div class="caption time">{{ as_at }}</div>
	</div>
</template>

<script>
const titles = ['', 'JOB NO.', 'JOB TITLE', 'STATUS', 'DIVISION'];

const titles_values = [
	'',
	'job_code',
	'job_short',
	'job_status',
	'job_division',
];
// We auto reload this data every minute!
import moment from 'moment';

import SortUpDown from '@/components/icons/sort_up_down';

export default {
	name: 'JobsIManage',
	components: {
		SortUpDown,
	},
	data() {
		return {
			titles: titles,
			titles_values: titles_values,
			jobs_list: [],
			timer: null,
			as_at: '',
			sortByAscent: false,
		};
	},
	beforeMount() {
		// update it for the first time
		this.update_jobs();
	},
	beforeDestroy() {
		if (this.timer) {
			// console.log("Clear timer");
			clearTimeout(this.timer);
		}
	},
	methods: {
		update_jobs() {
			// console.log("reload");

			let url = '/api/dashboard/myjobs';

			axios
				.get(url, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((d) => {
					let json = d.data;

					if (json.status == 'OK') {
						this.jobs_list = json.data;
						this.as_at =
							'as at ' + moment(new Date()).format('DD MMM YYYY h:mma');

						// attempt to update every minute
						this.timer = setTimeout(this.update_jobs, 60000);
					} else {
						console.log(json.reason);
					}
				})
				.catch((e) => {
					console.log(e.message);
				});
		},
		onSort(index) {
			const keyTmp = this.titles_values[index];
			this.sortByAscent = !this.sortByAscent;
			this.sortByAscent
				? this._sort_ascent(this.jobs_list, keyTmp)
				: this._sort_descent(this.jobs_list, keyTmp);
		},
		onAddTimesheet(job) {
			this.$emit('add-timesheet', job);
		},
		_sort_ascent(arr, key) {
			arr.sort((a, b) => {
				const valueA = a[key].toUpperCase(); // ignore upper and lowercase
				const valueB = b[key].toUpperCase(); // ignore upper and lowercase

				if (valueA < valueB) {
					return -1;
				}
				if (valueA > valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_descent(arr, key) {
			arr.sort((a, b) => {
				const valueA = a[key].toUpperCase(); // ignore upper and lowercase
				const valueB = b[key].toUpperCase(); // ignore upper and lowercase

				if (valueA > valueB) {
					return -1;
				}
				if (valueA < valueB) {
					return 1;
				}

				return 0;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.jobsyoumanage {
  padding: 6px 16px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  border-radius: 0 0 4px 4px;
}
.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  height: 40px;

  > :first-child {
    width: 120px;
		min-width: 120px;
		padding: 0;
		margin-left: 9px;
  }
  > :nth-child(2) {
		padding-left: 8px;
		width: calc((100% - 129px) * 0.25);
  }
  > :nth-child(3) {
		padding-left: 8px;
		width: calc((100% - 129px) * 0.25);
  }
  > :nth-child(4) {
		padding-left: 8px;
		width: calc((100% - 129px) * 0.25);
  }
  > :nth-child(5) {
		padding-left: 8px;
		width: calc((100% - 129px) * 0.25);
  }
}
.title-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
	text-overflow: ellipsis;
	white-space: nowrap;
  color: rgba(25, 42, 62, 0.7);
}
.icon-sort {
  width: 24px;
  height: 24px;
	:hover {
    cursor: pointer;
  }
}
.icon-sort .sort-up-down {
  width: 14px;
  height: 14px;
  margin-left: 6px;
}

.table-wrap {
  height: 80%;
  overflow: auto;
}
.table-wrap-xs {
  height: 90%;
  overflow: auto;
}
.table-container {
  height: 99%;
}
.table-row {
  height: 38px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin: 1px 0;
  > :first-child {
		min-width: 120px;
    width: 120px;
  }
}
.table-row-xs {
  height: 60px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
	align-items: center;
  margin: 4px 0;
	background: #eeeeee;
	padding-left: 8px;
}
.table-col-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  background: #eeeeee;
  width: calc(100% - 132px);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  height: 38px;

  &:hover {
    background: #dcdcdc;
    cursor: pointer;
  }

  :nth-child(2n + 1) {
    padding: 0 8px;
		flex: 1 1 0;
    // clip long text with '...'
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  :nth-child(2n) {
    padding: 0 8px;
		flex: 1 1 0;
    // clip long text with '...'
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.table-col-content-xs {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  background: #eeeeee;
  width: 85%;
	padding-left: 12px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.87);
  // height: 38px;

  &:hover {
    background: #dcdcdc;
    cursor: pointer;
  }
}
.text-code {
	font-size: 14px;
	color: rgba(25, 42, 62, 0.7);
}
.text-over {
	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.btn-add {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  overflow: hidden;
  color: #ffffff;
  background-color: #00aafd;
  border: 1px solid #00aafd;
  border-radius: 4px;
  margin: 3px 6px 3px 3px;

  &:hover {
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
  }
}
.btn-add-xs {
	display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: #00aafd;
  border: 1px solid #00aafd;
  border-radius: 4px;
	width: 44px;
	height: 44px;
	&:hover {
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
  }
}
.time {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0.4px;
  color: rgba(25, 42, 62, 0.36);
}
</style>
